import { SmartLink } from "@selector/shared/components";
import { type FC } from "react";

import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";

const HspCountCell: FC<IAgGridCellProps> = (props) => {
  const { value, data } = props;
  if (!data) {
    return null;
  }

  const tooltip = "Go to HSP table of hit " + data.rank;
  return (
    <TableCell>
      <SmartLink to={`/job/${data.jobId}/results/${data.queryId}/hsps/${data.rank}`} tooltip={tooltip} forceTooltip>
        {value}
      </SmartLink>
    </TableCell>
  );
};

export default HspCountCell;
